/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom';

import AppTopbar from './AppTopbar';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';

import Dashboard from './components/Dashboard';
import RegistrationFees from './pages/RegiserationFees/RegistrationFees';
import ReportManagement from './pages/Reports/ReportManagement';
import Login from './pages/Login';
import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import '@fortawesome/fontawesome-free/css/all.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import './assets/fonts/fonts.css';

import ShowMessageDialog from './utilities/ShowMessageDialog';
import { useSelector, useDispatch } from 'react-redux';
import { showMessageAction } from './redux/actions/showMessageAction';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from 'react-loading-overlay';
import UsersData from './pages/UsersData/UsersData';
import DashboardIcon from './assets/icons/Category.svg';
import userManagementIcon from './assets/icons/userManagement.svg';
import rolesManagementIcon from './assets/icons/Roles&Rights.svg';
import ResetPassword from './pages/Forgetpassword/ForgetPasswordOTP';
import reportsManagementIcon from './assets/icons/Reports.svg';
import feeAndFineManagementIcon from './assets/icons/RegistrationFees.svg';
import { refreshToken } from './services/Auth';
import PermitManagement from './pages/Permit/PermitManagement';
import PermitRenewalManagement from './pages/PermitRenewal/PermitRenewalManagement';
import AddEditPermit from './pages/Permit/AddEditPermit';
import AddEditPermitRenewal from './pages/PermitRenewal/AddEditPermitRenewal';
import ChangePasswordOTP from './pages/Forgetpassword/ChangePasswordOTP';
import AddEditPermitForm from './pages/Permit/AddEditPermitForm';
import FitnessCertificateManagement from './pages/FitnessCertificate/FitnessCertificateManagement';
import AddEditFitnessCertificate from './pages/FitnessCertificate/AddEditFitnessCertificate';
import FitnessCertificate from './pages/FitnessCertificate/FitnessCertificate';
import RenewFitnessCertificateManagement from './pages/FitnessCertificateRenewal/FitnessCertificateRenewalManagement';
import RenewFitnessCertificate from './pages/FitnessCertificateRenewal/RenewFitnessCertificate';
import RoutesManagement from './pages/Routes/RoutesManagement';
import FitnessFeeManagement from './pages/FitnessFeeANDFineManagement/FitnessFeeManagement';
import BatchManagement from './pages/Batch/BatchManagement';
import ProtectedRoute from './components/routing/ProtectedRoute';
import Unauthorized from './components/routing/Unauthorized';

const App = (props) => {
    const [userMenu, setUserMenu] = useState(JSON.parse(sessionStorage.getItem('menu')));
    const [path, setPath] = useState(window?.location?.href?.split('/#')?.pop());
    // const [foundMenu, setFoundMenu] = useState(null);
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('sidebar');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(true);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(true);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(true);
    const [pinActive, setPinActive] = useState(true);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState(null);
    const [token, setToken] = useState(false);

    const copyTooltipRef = useRef();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    require('dotenv').config();

    PrimeReact.ripple = true;
    LoadingOverlay.propTypes = undefined;

    const isLoading = useSelector((state) => state?.utilitySlice?.isLoading);
    const auth = useSelector((state) => state?.authenticationSlice?.token);
    const isNewUser = sessionStorage.getItem('isNewUser');

    const showModal = useSelector((state) => state?.showMessageSlice?.showModal);
    const message = useSelector((state) => state?.showMessageSlice?.message);
    const isError = useSelector((state) => state?.showMessageSlice?.isError);
    const url = useSelector((state) => state?.showMessageSlice?.url);

    const allMenuItems = [
        {
            label: 'Dashboard',
             icon: 'pi pi-home',
            to: '/'
        },
        {
            label: 'User Management',
            icon: userManagementIcon,
            to: '/usersdata'
        },
        {
            label: 'Permit Fee & Fine Management',
            icon: 'pi pi-money-bill',
            to: '/registrationFeeManagement'
        },
        {
            label: 'Fitness Fee & Fine Management',
            icon: 'pi pi-wallet',
            to: '/feefinemanagement'
        },
         {
            label: 'Routes Management',
            icon: 'pi pi-map',
            to: '/routes-management'
        },
        
       
    ];

    const roleName = localStorage.getItem('roleName');

    let menu = [];

    switch (roleName) {
        case 'SuperAdmin':
            menu = allMenuItems;
            break;
        case 'Data Entry Operator':
            menu = [
                {
                    label: 'Dashboard',
                     icon: 'pi pi-home',
                    to: '/'
                },
                {
                    label: 'Permit Requests',
                    icon: 'pi pi-file-edit',
                    to: '/permit-requests'
                },
                {
                    label: 'Permit Renewal',
                    icon: 'pi pi-sync',
                    to: '/permit-renewal'
                },
                {
                    label: 'Batch Payments',
                    icon: 'pi pi-qrcode',
                    to: '/batch-management'
                }
            ];
            break;
        case 'Fitness Officer':
            menu = [
                {
                    label: 'Dashboard',
                     icon: 'pi pi-home',
                    to: '/'
                },
                {
                    label: 'Fitness Certificate',
                    icon: 'pi pi-id-card',
                    to: '/fitnessCertificate'
                },
                {
                    label: 'Fitness Certificate Renewal',
                    icon: 'pi pi-refresh',
                    to: '/fitnessrenewal'
                },
                {
                    label: 'Batch Payments',
                    icon: 'pi pi-qrcode',
                    to: '/batch-management'
                }
            ];
            break;
        case 'Deputy Director':
        case 'DC Office':
            menu = [
                {
                    label: 'Dashboard',
                     icon: 'pi pi-home',
                    to: '/'
                },
                {
                    label: 'Permit Requests',
                    icon: 'pi pi-file-edit',
                    to: '/permit-requests'
                },
                {
                    label: 'Permit Reports',
                    icon: 'pi pi-file',
                    to: '/Reports'
                }
            ];
            break;
        default:
            menu = [];
            break;
    }

    const routes = [{ label: 'Dashboard' }, { label: 'Users Data' }, { label: 'Add Point Redemption' }, { label: 'Edit Point Redemption' }, { label: 'View Point Redemption' }, { label: 'Edit Zmiles Voucher' }];

    let rightMenuClick;

    let configClick;
    let menuClick;
    let searchClick = false;
    let topbarItemClick;

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        configClick = false;
        rightMenuClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };

    const onRightMenuButtonClick = () => {
        rightMenuClick = true;
        setRightMenuActive(true);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event.preventDefault();
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const onInputClick = () => {
        searchClick = true;
    };

    const breadcrumbClick = () => {
        searchClick = true;
        setSearchActive(true);
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'p-ripple-disabled': !ripple
    });

    const handleLogout = () => {
        navigate('/');
        sessionStorage.clear();
        window.location.reload();
        toast.warn('Logged out because of inactivity');
    };

    const handleShowModal = () => {
        dispatch(showMessageAction({ isShowModal: false, message: '', isError }));
    };

    const loadUrl = (url) => {
        navigate(url);
    };

    const dialogProps = {
        showModal,
        message,
        isError,
        handleShowModal,
        loadUrl,
        url
    };

    useEffect(() => {
        setPath(window.location.href?.split('/#')?.pop());
    }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const checkAndRefreshToken = async () => {
            if (sessionStorage.getItem('token') === null && sessionStorage.getItem('refreshToken') !== null) {
                const response = await dispatch(refreshToken(sessionStorage.getItem('refreshToken')));
                if (response?.success) {
                    console.log(response);
                    sessionStorage.setItem('token', response?.data?.token);
                } else {
                    // Handle failed refresh
                    sessionStorage.clear();
                    localStorage.clear();
                    window.location.href = '/';
                }
            }
        };

        checkAndRefreshToken();
    }, []);

    useEffect(() => {
        if (window.top !== window.self) {
            window.top.location = window.self.location;
        }
    }, []);

    const tok = sessionStorage.getItem('token');

    console.log(auth);
    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <LoadingOverlay active={isLoading} spinner text="Please Wait ...">
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
                <ShowMessageDialog {...dialogProps} />
                {/* <NotificationComponent /> */}
                <ToastContainer />

                {tok === null ? (
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/reset-password" exact="true" element={<ResetPassword />} />
                        <Route path="/change-password" element={<ChangePasswordOTP />} />
                    </Routes>
                ) : (
                    <div className="layout-main">
                        <AppTopbar
                            items={menu}
                            menuMode={menuMode}
                            colorScheme={props.colorScheme}
                            menuActive={menuActive}
                            topbarMenuActive={topbarMenuActive}
                            activeInlineProfile={activeInlineProfile}
                            onTopbarItemClick={onTopbarItemClick}
                            onMenuButtonClick={onMenuButtonClick}
                            onSidebarMouseOver={onSidebarMouseOver}
                            onSidebarMouseLeave={onSidebarMouseLeave}
                            onToggleMenu={onToggleMenu}
                            onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                            onMenuClick={onMenuClick}
                            onMenuItemClick={onMenuItemClick}
                            onRootMenuItemClick={onRootMenuItemClick}
                            resetActiveIndex={resetActiveIndex}
                        />

                        <AppMenu
                            model={menu}
                            onRootMenuItemClick={onRootMenuItemClick}
                            onMenuItemClick={onMenuItemClick}
                            onToggleMenu={onToggleMenu}
                            onMenuClick={onMenuClick}
                            menuMode={menuMode}
                            colorScheme={props.colorScheme}
                            menuActive={menuActive}
                            sidebarActive={sidebarActive}
                            sidebarStatic={sidebarStatic}
                            pinActive={pinActive}
                            onSidebarMouseLeave={onSidebarMouseLeave}
                            onSidebarMouseOver={onSidebarMouseOver}
                            activeInlineProfile={activeInlineProfile}
                            onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                            resetActiveIndex={resetActiveIndex}
                        />

                        <div className="layout-main-content">
                            <Routes>
                                <Route path="/" element={<ProtectedRoute path="/"><Dashboard /></ProtectedRoute>} />
                                <Route path="/usersdata" element={<ProtectedRoute path="/usersdata"><UsersData /></ProtectedRoute>} />
                                <Route path="/registrationFeeManagement" element={<ProtectedRoute path="/registrationFeeManagement"><RegistrationFees /></ProtectedRoute>} />
                                <Route path="/feefinemanagement" element={<ProtectedRoute path="/feefinemanagement"><FitnessFeeManagement /></ProtectedRoute>} />
                                <Route path="/Reports" element={<ProtectedRoute path="/Reports"><ReportManagement /></ProtectedRoute>} />
                                <Route path="/permit-requests" element={<ProtectedRoute path="/permit-requests"><PermitManagement /></ProtectedRoute>} />
                                <Route path="/permit-requests/edit/:id" element={<ProtectedRoute path="/permit-requests/edit/:id"><AddEditPermitForm mode="edit" /></ProtectedRoute>} />
                                <Route path="/permit-requests/view/:id" element={<ProtectedRoute path="/permit-requests/view/:id"><AddEditPermitForm mode="view" /></ProtectedRoute>} />
                                <Route path="/routes-management" element={<ProtectedRoute path="/routes-management"><RoutesManagement /></ProtectedRoute>} />
                                <Route path="/permit-requests/add" element={<ProtectedRoute path="/permit-requests/add"><AddEditPermitForm /></ProtectedRoute>} />
                                <Route path="/permit-renewal" element={<ProtectedRoute path="/permit-renewal"><PermitRenewalManagement /></ProtectedRoute>} />
                                <Route path="/permit-renewal/edit/:id" element={<ProtectedRoute path="/permit-renewal/edit/:id"><AddEditPermitRenewal mode="edit" /></ProtectedRoute>} />
                                <Route path="/permit-renewal/view/:id" element={<ProtectedRoute path="/permit-renewal/view/:id"><AddEditPermitRenewal mode="view" /></ProtectedRoute>} />
                                <Route path="/permit-renewal/add" element={<ProtectedRoute path="/permit-renewal/add"><AddEditPermitRenewal /></ProtectedRoute>} />
                                <Route path="/fitnessCertificate" element={<ProtectedRoute path="/fitnessCertificate"><FitnessCertificateManagement /></ProtectedRoute>} />
                                <Route path="/addfitness" element={<ProtectedRoute path="/addfitness"><AddEditFitnessCertificate /></ProtectedRoute>} />
                                <Route path="/fitnesscer" element={<ProtectedRoute path="/fitnesscer"><FitnessCertificate /></ProtectedRoute>} />
                                <Route path="/fitnessrenewal" element={<ProtectedRoute path="/fitnessrenewal"><RenewFitnessCertificateManagement /></ProtectedRoute>} />
                                <Route path="/batch-management" element={<ProtectedRoute path="/batch-management"><BatchManagement /></ProtectedRoute>} />
                                
                                {/* Add unauthorized route */}
                                <Route path="/unauthorized" element={<Unauthorized />} />
                                
                                {/* Catch-all route */}
                                <Route path="*" element={<Navigate to="/unauthorized" replace />} />
                            </Routes>
                        </div>

                        {/* <AppFooter colorScheme={props.colorScheme} /> */}
                    </div>
                )}
                <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} />
                <AppConfig
                    configActive={configActive}
                    onConfigButtonClick={onConfigButtonClick}
                    onConfigClick={onConfigClick}
                    menuMode={menuMode}
                    changeMenuMode={onMenuModeChange}
                    colorScheme={props.colorScheme}
                    changeColorScheme={props.onColorSchemeChange}
                    theme={props.theme}
                    changeTheme={props.onMenuThemeChange}
                    componentTheme={props.componentTheme}
                    changeComponentTheme={props.onComponentThemeChange}
                    ripple={ripple}
                    onRippleChange={onRippleChange}
                />
            </LoadingOverlay>
        </div>
    );
};

export default App;
